import { totemTypes } from "../../reducers/totem/totemTypes";

export const setActiveBreadcrumbTotem = (activeBreadcrumb) => ({
    type: totemTypes.setActiveBreadcrumbTotem,
    payload: activeBreadcrumb,
  });